import Http from '../services/http.service';

const System = {};
System.contact = async (email, comments, feedback) => (await Http.get().post(`${process.env.VUE_APP_API}/1/user/contact`, {email, comments, feedback})).data;
System.subscribe = async (email) => (await Http.get().post(`${process.env.VUE_APP_API}/1/user/subscribe`, {email})).data;
System.requestTrial = async (email, name, link, captcha) => (await Http.get().post(`${process.env.VUE_APP_API}/1/user/trial`, {email, name, about: link, captcha})).data;
export default System;
